import { z } from 'zod/v3';
import { UserCalendarSchema } from './UserCalendarSchema';

export type UserCalendarDto = z.infer<typeof UserCalendarSchema>;

export enum UserCalendarExecutionType {
  IN_DEAD = 'IN_DEAD',
  OUT_DEAD = 'OUT_DEAD',
  OUT_PUB = 'OUT_PUB',
}
